import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, forkJoin, map, throwError, catchError, of } from 'rxjs';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { ServiceAdministrationService } from '../service/service-administration.service';

@Component({
    selector: 'app-delete-service-administration-check',
    templateUrl: './delete-service-administration-check.component.html',
    styleUrls: ['./delete-service-administration-check.component.scss']
})
export class DeleteServiceAdministrationCheckComponent implements OnInit {
    isLoading: boolean = false;
    confirmMsg: MsgModel = {};
    msg: MsgModel = {};
    submitting: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<DeleteServiceAdministrationCheckComponent>,
        private serviceAdministrationService: ServiceAdministrationService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        this.getAll();
    }

    getAll() {
        this.isLoading = true;
        this.msg = {};

        let obs: Observable<any>[] = [];

        obs.push(this.deleteCheck());

        forkJoin(obs).subscribe((res) => {
            this.isLoading = false;
        });
    }

    deleteCheck() {
        return this.serviceAdministrationService.deleteCheck(this.data.serviceAdministrationId).pipe(
            map((res: any) => {
                if (res.msg) {
                    this.confirmMsg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error checking if Service Administration can be deleted.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    delete() {
        this.submitting = true;
        this.dialogRef.disableClose = true;

        this.serviceAdministrationService.delete_(this.data.serviceAdministrationId).subscribe({
            next: (res) => {
                if (res.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = { SUCCESS: false, MSG: 'Error deleting Service Adminstrations.' };
                }
            },
            error: (err) => {
                this.msg = { SUCCESS: false, MSG: 'Error deleting Service Adminstrations.' };
            },
            complete: () => {
                if (this.msg.SUCCESS) {
                    this.closeDialog(true);
                } else {
                    this.submitting = false;
                }
            }
        });
    }

    closeDialog(refresh?: boolean) {
        this.dialogRef.close(refresh);
    }
}
